module.exports = __webpack_public_path__ + "img/193.a520dfbb.jpg";